<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <path d="M12 4v11"/>
        <path d="m7 11 5 5 5-5"/>
        <path d="M4 19h16"/>
    </svg>
</template>
